import filterTypes from '../../components/Revenue/filterTypes';
import reportTypes from '../../components/Revenue/ReportTypes';

export class revenueReportItems {
    constructor() {
        this.items = [
            {
                id: 1,
                name: filterTypes.Apps,
                type: reportTypes.Apps,
                isVisible: true,
                filters: [filterTypes.Apps, filterTypes.Platform]
            },
            {
                id: 6,
                name: filterTypes.AppsPlacements,
                type: reportTypes.AppsPlacements,
                isVisible: true,
                filters: [filterTypes.Apps, filterTypes.Platform, filterTypes.Placement]
            },
            {
                id: 2,
                name: filterTypes.Date,
                type: reportTypes.Date,
                isVisible: true,
                filters: [filterTypes.Apps, filterTypes.Platform]
            },
            {
                id: 3,
                name: filterTypes.Country,
                type: reportTypes.Country,
                isVisible: true,
                filters: [filterTypes.Apps, filterTypes.Platform, , filterTypes.Country]
            },
            {
                id: 7,
                name: filterTypes.CountryPlacement,
                type: reportTypes.CountryPlacement,
                isVisible: true,
                filters: [filterTypes.Apps, filterTypes.Platform, filterTypes.Country, filterTypes.Placement]
            },
            {
                id: 4,
                name: filterTypes.Advertiser,
                type: reportTypes.Advertiser,
                isVisible: false,
                filters: [filterTypes.Apps, filterTypes.Platform, filterTypes.Advertiser]
            },
            {
                id: 5,
                name: filterTypes.Placement,
                type: reportTypes.Placement,
                isVisible: true,
                filters: [filterTypes.Apps, filterTypes.Platform]
            },
            {
                id: 8,
                name: filterTypes.PlacementCountry,
                type: reportTypes.PlacementCountry,
                isVisible: true,
                filters: [filterTypes.Apps, filterTypes.Platform, filterTypes.Placement, filterTypes.Country]
            }
        ]
    }
}

export class revenueFilterItems {
    constructor() {
        this.items = [
            {
                id: filterTypes.Apps,
                name: filterTypes.Apps,
                type: 'checkbox',
                options:
                    [
                        {
                            id: filterTypes.Apps,
                            name: "All " + filterTypes.Apps,
                            platform: undefined,
                            selected: true,
                            visible: true,
                            isAll: true,
                            isAllSelected: false
                        }
                    ]
            },
            {
                id: filterTypes.Country,
                name: filterTypes.Country,
                type: 'checkbox',
                options:
                    [
                        {
                            id: filterTypes.Country,
                            name: "All " + filterTypes.Country,
                            platform: undefined,
                            selected: true,
                            visible: true,
                            isAll: true,
                            isAllSelected: false
                        }
                    ]
            },
            {
                id: filterTypes.Advertiser,
                name: filterTypes.Advertiser,
                type: 'checkbox',
                options:
                    [
                        {
                            id: filterTypes.Advertiser,
                            name: "All " + filterTypes.Advertiser,
                            platform: undefined,
                            selected: true,
                            visible: true,
                            isAll: true,
                            isAllSelected: false
                        }
                    ]
            },
            {
                id: filterTypes.Placement,
                name: filterTypes.Placement,
                type: 'checkbox',
                options:
                    [
                        {
                            id: filterTypes.Placement,
                            name: "All " + filterTypes.Placement,
                            platform: undefined,
                            selected: true,
                            visible: true,
                            isAll: true,
                            isAllSelected: false
                        }
                    ]
            },
            {
                id: filterTypes.Platform,
                name: filterTypes.Platform,
                type: 'radio',
                options:
                    [
                        {
                            id: 1,
                            name: 'All',
                            selected: true,
                            visible: true,
                            isAll: true
                        },
                        {
                            id: 2,
                            name: 'Android',
                            selected: false,
                            visible: true,
                            isAll: false
                        },
                        {
                            id: 3,
                            name: 'iOS',
                            selected: false,
                            visible: true,
                            isAll: false
                        }
                    ]
            }
        ]
    }
};


// WEBPACK FOOTER //
// ./src/components/Revenue/model.js